<template>
<div class="breadcum-cust-outer">
    <div class="breadcum-cust">
        <div class="breadcum-item">
            <router-link :to="{ name: this.route.meta.breadcrumb[0].url}">
                {{ $t(`pages.${this.route.meta.breadcrumb[0].title}`) }} <span>&gt;</span>
            </router-link>
        </div>
        <div v-for="(link, index) in this.route.meta.breadcrumb.slice(1,-1)" :key="index" class="breadcum-item">
            <router-link :to="{ name: link.url}" v-if="link.url">
                {{ $t(`pages.${link.title}`) }} <span>&gt;</span>
            </router-link>
        </div>
        <div v-if="this.route.meta.breadcrumb.length>1 && this.route.meta.breadcrumb.slice(-1)[0].active" class="breadcum-item black-item">
            <a href="#">
                {{ $t(`pages.${this.route.meta.breadcrumb.slice(-1)[0].title}`) }}
            </a>
        </div>
    </div>
    <!-- <div class="breadcum-cust">
        <div class="breadcum-item black-item">
            <router-link to="/" >
                <span>&lt;</span> Retour
            </router-link>
        </div>
    </div> -->
</div>
</template>

<script>
export default {
    props: {
        route: {}
    }
}
</script>